module.exports = __webpack_public_path__ + "img/138.9.85f27171.png";